import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import './MyCertificate.css';
import api from '../../api';
import { useNavigate } from 'react-router-dom'; // Import useNavigate to handle redirection

const MyCertificate = () => {
  const { profile, token } = useAuth();
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCertificate, setSelectedCertificate] = useState(null); // State for selected certificate
  const navigate = useNavigate(); // Hook for redirecting

  useEffect(() => {
    const fetchCertificates = async () => {
      if (!profile || !profile._id) {
        console.error('User profile is not available');
        return;
      }

      try {
        const response = await axios.get(api.getCertificatesByUser(profile._id), {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCertificates(response.data.certificates);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching certificates:', error);
        setLoading(false);
      }
    };

    if (profile && profile._id) {
      fetchCertificates();
    } else {
      setLoading(false);
    }
  }, [profile, token]);

  if (loading) {
    return <div>Loading...</div>;
  }

  const handleViewCertificate = (cert) => {
    // Redirect to the certificate view page
    const certificateUrl = `/publicCertificateView/${cert._id}`; // Construct the URL for the certificate
    navigate(certificateUrl); // Perform the redirection
  };
  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="pcv-container">
      <div className="pcv-header">
        <h1 className="pcv-title">My Certificates </h1>
        <div className="pcv-button-group">
          <button onClick={handleGoBack} className="pcv-button pcv-button-back">
                        Go Back
          </button>
               
        </div>
      </div>

      <div className="my-certificates">
        <div className="certificate-list">
          {certificates.length === 0 ? (
            <p>No certificates available.</p>
          ) : (
            certificates.map(cert => (
              <div key={cert._id} className="certificate-item">
                <p className="certificate-title">
                                    Course: {cert.courseId ? cert.courseId.title : 'Course title not available'}
                </p>
                <button
                  onClick={() => handleViewCertificate(cert)}
                  className="certificate-link"
                >
                                    View Certificate
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default MyCertificate;
